import Button from '@carvana/ds-button';
import React from 'react';
import EventedModal from '|/app/modals/evented-modal';
import { ModalNames } from '|/app/modals/modal-events';
import useAnalyticsContext from '|/hooks/use-analytics-context';
import styles from './ExitWarningModal.module.css';

export interface ExitWarningModalProps {
  isOpen: boolean;
  fromNavRail?: boolean;
  outOfAttempts?: boolean;
  onClose: () => void;
  onLeave: () => void;
}

export const ExitWarningModal: React.FC<ExitWarningModalProps> = ({
  isOpen,
  fromNavRail,
  outOfAttempts,
  onClose,
  onLeave
}) => {
  let subtitleText: string;
  if (!fromNavRail) {
    subtitleText = outOfAttempts
      ? "If you leave this page, your session will end and you won't be able to verify your identity or finance with Carvana for 30 days."
      : 'If you leave this page, your session will end—leaving you with one final attempt.';
  } else {
    subtitleText = 'If you leave this page, your session will end.';
  }
  const { trackEvent } = useAnalyticsContext();

  const handleLeave = () => {
    trackEvent('pp_identity_verification_leave');
    onLeave();
  };
  const handleStay = () => {
    trackEvent('pp_identity_verification_stay');
    onClose();
  };

  return (
    <EventedModal
      isOpen={isOpen}
      analyticsId={ModalNames.ExitWarning}
      closeIcon={true}
      divLine={false}
      mobileStyle="inset"
      contentPadding={false}
      onClose={onClose}
    >
      <div className={styles.modalContainer}>
        <h1 className={styles.title}>Are you sure you want to leave?</h1>
        <p className={styles.subtitle}>{subtitleText}</p>
        <div className={styles.buttonWrapper}>
          <Button
            variant="secondary"
            size="lg"
            onClick={handleLeave}
            data-analytics-id="pp_identity_verification_leave_speed_bump"
          >
            End session
          </Button>
          <Button
            variant="primary"
            size="lg"
            onClick={handleStay}
            data-analytics-id="pp_identity_verification_stay_speed_bump"
          >
            Stay & continue
          </Button>
        </div>
      </div>
    </EventedModal>
  );
};

export default ExitWarningModal;
